import { ReactNode } from 'react';
import { Event } from '@blisspointmedia/bpm-types/dist/OracleActivity';
import { AppFieldOf, TextField } from '@Components/Forms/FormField';
import { EventFormEditor } from './useEditEventForm';

type TextBlockKey = 'details' | 'recommendedAction';

interface DetailTextBlockProps {
  event: Event;
  dataKey: TextBlockKey;
  label: string;
  required?: boolean;
  editor?: EventFormEditor;
}

export const DetailTextBlock = ({
  event,
  dataKey,
  label,
  required = false,
  editor
}: DetailTextBlockProps): ReactNode => {
  if (!editor && !event[dataKey]) return undefined;

  return (
    <div className='activity-feed-detail-text-block'>
      {editor ? (
        <AppFieldOf
          form={editor.form}
          name={dataKey}
          field={TextField}
          fieldProps={{
            multiline: true,
            rows: 4,
            label,
            required,
            fieldClassName: 'activity-feed-detail-field',
            labelClassName: 'activity-feed-detail-text-label editable',
            disabled: editor.disabled
          }}
        />
      ) : (
        <>
          <p className='activity-feed-detail-text-label'>{label}</p>
          <p className='activity-feed-detail-text-body'>{event[dataKey]}</p>
        </>
      )}
    </div>
  );
};
